import { useMemo } from 'react'

import { SimpleSelectOption } from '@workwave-tidal/core/components'

export function useTerritoryDropdownItems(
  territories: Record<string, uui.domain.client.rm.Territory>,
  territoryId: string,
) {
  return useMemo<SimpleSelectOption<string>[]>(
    () =>
      Object.values(territories).map(
        (territory): SimpleSelectOption<string> => ({
          value: territory.id,
          label: territory.name,
        }),
      ),
    [territories, territoryId],
  )
}
